import React from "react";

const workflow = [
  {
    step: "1",
    emoji: "🛒",
    title: "Purchase Session Pass",
    desc: "The Organizer purchases a Reunion Session Pass using Think5Whys FuelStash Credits.",
  },
  {
    step: "2",
    emoji: "🏛️",
    title: "Create Reunion Hall",
    desc: "Create a Reunion Hall by entering Hall Name, Sponsor, Entry Passes, Prize Details and other event settings.",
  },
  {
    step: "3",
    emoji: "📨",
    title: "Share Entry Pass",
    desc: "Share the Entry Pass with all participants through WhatsApp or any preferred communication channel.",
  },
  {
    step: "4",
    emoji: "📲",
    title: "Participants Join",
    desc: "Participants log into Think5Whys → PurpleDoor → Reunion and join using the Entry Pass.",
  },
  {
    step: "5",
    emoji: "🎮",
    title: "Go Live",
    desc: "The Organizer starts the Reunion and everyone begins answering questions together in real time.",
  },
  {
    step: "6",
    emoji: "🏆",
    title: "Celebrate Winners",
    desc: "Reveal Semi Finalists, announce the Winners and celebrate the occasion together.",
  },
];

const ReunionWorkflow = () => {
  return (
    <section className="relative py-20 px-6 bg-gradient-to-b from-[#081311] via-[#071b18] to-[#04110e]">

      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-4">

          <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-emerald-500/10 border border-emerald-400/20 mb-5">
            <span className="text-xl">🚀</span>
            <span className="uppercase tracking-[0.3em] text-xs font-semibold text-emerald-300">
              How Reunion Works
            </span>
          </div>

          <h2 className="text-3xl lg:text-5xl font-black text-white mb-5">
            Create.
            <br />
            Connect.
            <br />
            Celebrate.
          </h2>

          <p className="max-w-3xl mx-auto text-emerald-100/80 text-sm lg:text-lg leading-relaxed">
            Organizing an exciting live community event takes just a few simple
            steps. Create your Reunion Hall, invite participants and let the
            celebration begin.
          </p>

        </div>

        {/* Workflow */}
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">

          {workflow.map((item) => (
            <div
              key={item.step}
              className="relative rounded-3xl bg-white/5 border border-white/10 backdrop-blur-md p-7 hover:border-emerald-400/40 hover:bg-emerald-500/10 transition-all duration-300 hover:-translate-y-2"
            >

              {/* Step Badge */}
              <div className="absolute -top-4 left-6 h-10 w-10 rounded-full bg-gradient-to-r from-emerald-500 to-green-600 flex items-center justify-center font-black text-white shadow-lg">
                {item.step}
              </div>

              <div className="text-5xl mt-4 mb-5">
                {item.emoji}
              </div>

              <h3 className="text-xl font-bold text-white mb-3">
                {item.title}
              </h3>

              <p className="text-sm text-emerald-100/80 leading-relaxed">
                {item.desc}
              </p>

            </div>
          ))}

        </div>

        {/* Bottom Highlight */}
        <div className="mt-16 rounded-3xl border border-emerald-500/20 bg-gradient-to-r from-emerald-500/10 via-teal-500/10 to-purple-500/10 p-8 text-center">

          <div className="text-5xl mb-4">🫂</div>

          <h3 className="text-2xl lg:text-3xl font-black text-white mb-4">
            From Entry Pass to Winner Celebration
          </h3>

          <p className="max-w-4xl mx-auto text-emerald-100/80 text-sm lg:text-lg leading-relaxed">
            Reunion makes every gathering interactive by bringing people
            together through live participation, healthy competition and joyful
            celebrations—all from their smartphones.
          </p>

        </div>

      </div>

    </section>
  );
};

export default ReunionWorkflow;